import $ from 'jquery';
import simpleLightbox from 'simplelightbox';

function initLightbox() {
    const galleries = document.querySelectorAll('.js-masonry');
    if (galleries.length < 1) return;

    function initSocialButtons() {
        const buttonContainer = document.querySelector('.lightbox-sharing-buttons-container');
        const pinterestBtn = this.querySelector('.social-share-button-pinterest'); // this refers to the link we clicked to open the lightbox
        // if there is no pinterest button or no button container return
        if (!pinterestBtn || !buttonContainer) return;
        const clonedButton = pinterestBtn.cloneNode(true);
        // else clear the container and append the button
        buttonContainer.innerHTML = '';
        buttonContainer.appendChild(clonedButton);
    }

    function getLightboxIndexToOpen() {
        const locationHash = window.location.hash;
        if (locationHash.includes('pid')) {
            // search for numbers in the string and get an array of the matches
            const lightboxIndexToOpen = locationHash.match(/\d+/);
            if (typeof lightboxIndexToOpen === 'object' && lightboxIndexToOpen.length >= 1) {
                return (lightboxIndexToOpen[0]); // return first match
            }
        }
    }


    const lightboxOptions = {
        navText: [
            '<svg class="icon-angle-left-color"><use xlink:href="#angle-left-color"></use></svg>',
            '<svg class="icon-angle-right-color"><use xlink:href="#angle-right-color"></use></svg>'
        ],
        closeText: '<svg class="icon-close-color"><use xlink:href="#close-color"></use></svg>',
		captionSelector: 'self', // the link
		captionType: 'data',
        captionsData: 'caption',
        captionPosition: 'outside',
        swipeClose: false,
        heightRatio: .75,
        docClose: false,
        additionalHtml: '<div class="lightbox-sharing-buttons-container"></div>',
        showCounter: false,
        spinner: false,
    };

    for (let i = 0; i < galleries.length; i++) {
        const lightbox = $(galleries[i]).find('a.js-lightbox').simpleLightbox(lightboxOptions);
        lightbox.on('shown.simplelightbox', initSocialButtons);
        lightbox.on('changed.simplelightbox', initSocialButtons);
        window.addEventListener('load', () => {
            // Check if url contains #pid and if so, open lightbox with the correct number
            const index = getLightboxIndexToOpen();
            if (index > 0 && index < lightbox.length) {
                lightbox[index - 1].click();
            }
        });
    }
}
initLightbox();
